import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

export const useDraftActions = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const editDraft = (draftId: string) => {
    navigate(`/create-campaign?draft=${draftId}`);
  };

  const deleteDraft = async (draftId: string, onSuccess?: () => void) => {
    setDeletingId(draftId);
    
    try {
      // Utiliser la Edge Function pour la suppression en cascade
      const { error } = await supabase.functions.invoke('delete-campaign-cascade', {
        body: { campaignId: draftId }
      });

      if (error) throw error;

      toast({
        title: "Brouillon supprimé",
        description: "Le brouillon a été supprimé avec succès.",
      });

      if (onSuccess) onSuccess();
    } catch (error: any) {
      console.error('Error deleting draft:', error);
      toast({
        title: "Erreur",
        description: "Impossible de supprimer le brouillon.",
        variant: "destructive",
      });
    } finally {
      setDeletingId(null);
    }
  };

  return {
    editDraft,
    deleteDraft,
    deletingId,
  };
};